export default function ImportResult({ result }) {
  var hasErrors = result.errors && result.errors.length > 0;
  var errorCount = hasErrors ? result.errors.length : 0;
  return (
    <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-4" data-testid="import-result">
      <p className="text-sm font-medium text-emerald-800 mb-2">Importacao concluida!</p>
      <p className="text-xs text-emerald-700">Clientes criados: <strong>{result.clients_created}</strong></p>
      <p className="text-xs text-emerald-700">Clientes atualizados: <strong>{result.clients_updated}</strong></p>
      {result.consortiums_created > 0 && <p className="text-xs text-emerald-700">Consorcios criados: <strong>{result.consortiums_created}</strong></p>}
      {hasErrors && <p className="text-xs text-amber-700 mt-2 font-medium">{errorCount} aviso(s) durante a importacao</p>}
    </div>
  );
}
